export enum VendorCodeType {
  COMMERCIAL = 'Commercial',
  COMMERCIAL_HOME_WARRANTY = 'CommercialHomeWarranty',
  INTERNET = 'Internet',
  INTERNET_HOME_WARRANTY = 'InternetHomeWarranty',
}
